import { memo } from "react";
import { Center, Flex, Image, Text, Title } from "@mantine/core";
import { client_selected } from "../../client";
import { useMediaQuery } from "@mantine/hooks";

const PageMaintenance = () => {
  const logo = client_selected.image.logo2;
  const isLargerThan650 = useMediaQuery("(min-width: 650px)");
  return (
    <Center p={{ base: 24, 991: 120 }} h="100vh" w="100vw">
      <Flex
        w="100%"
        maw={945}
        bg="basic.0"
        align="center"
        justify="center"
        style={{
          boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.1)",
          borderRadius: "20px",
          overflow: "hidden",
        }}
        p={{ base: "24px", 991: "48px" }}
      >
        <Flex direction="column" gap={40} align="center" justify="center">
          <Image
            src={logo}
            height={"auto"}
            width={isLargerThan650 ? "340px" : "200px"}
            fit="contain"
            alt="logo-trader"
          />
          <Flex direction="column" gap={24} w="100%">
            <Title
              w="100%"
              fw={600}
              fz={{ base: 24, 991: 32 }}
              lh={{ base: "40px", 991: "50px" }}
              color="basic.5"
            >
              Estamos em manutenção!
            </Title>
            <Text
              fw={400}
              fz={{ base: 18, 991: 24 }}
              lh={{ base: "32px", 991: "40px" }}
              color="basic.5"
            >
              Nosso site está passando por uma manutenção programada para
              melhorias.
              <br /> Voltamos em breve com tudo funcionando perfeitamente para
              te atender ainda melhor. Agradecemos a sua compreensão!
            </Text>
            <Text
              fw={500}
              fz={{ base: 18, 991: 24 }}
              lh={{ base: "32px", 991: "40px" }}
              color="basic.5"
            >
              <i>{client_selected.name}</i>
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Center>
  );
};

export default memo(PageMaintenance);
